// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTooltip-cls1_nM-","cls2":"UserTooltip-cls2_oy2 UserTooltip-cls1_nM-"};